import React from 'react';

const FacebookVideo = ({ videoId, autoplay = true }) => {
    // videoId = '2358467037849725';
    // videoId = '1196320265233893';
    // videoId = '976231908016325';

    // '<iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F2358467037849725%2F&show_text=false&width=267&t=0" width="267" height="476" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>'
    // '<iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1196320265233893%2F&show_text=false&width=267&t=0" width="267" height="476" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>';
    // const videoUrl = `https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F${videoId}%2F&show_text=false&width=267&t=0`;
    const videoUrl = `https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Freel%2F${videoId}%2F&autoplay=${autoplay}`;
    // const videoUrl = `https://www.facebook.com/plugins/video.php?href=https://www.facebook.com/facebook/videos/${videoId}/&show_text=false&autoplay=${autoplay}`;
    // const thumbnail = 'https://graph.facebook.com/v18.0/${videoId}?fields=picture'
    
    // get thumbnail
    // 'https://graph.facebook.com/v18.0/2358467037849725?fields=picture'
    // {
    //     "picture": "https://scontent.fyto1-1.fna.fbcdn.net/v/t15.5256-10/474959872_801645572135944_2697103413569384404_n.jpg?stp=dst-jpg_p160x160_tt6&_nc_cat=108&ccb=1-7&_nc_sid=442ec5&_nc_ohc=LbFPvd08KBgQ7kNvwGOEgq3&_nc_oc=AdnIay_kMVNBoajL-bwoiDQVGzX-VeNalEsrsM5D8abQv9O4PjmzpEQy8F6RrWe3yhE&_nc_zt=23&_nc_ht=scontent.fyto1-1.fna&edm=APRAPSkEAAAA&_nc_gid=NiKS_-fYET_bQ-HwiPSALQ&oh=00_AfIZNuwuOQ1HMMKtOiuUnwm99iK6hnMRJN9CcnOHVGPX0A&oe=6841269F",
    //     "id": "2358467037849725"
    // }
    // 'https://scontent.fyto1-1.fna.fbcdn.net/v/t15.5256-10/474959872_801645572135944_2697103413569384404_n.jpg?stp=dst-jpg_p160x160_tt6&_nc_cat=108&ccb=1-7&_nc_sid=442ec5&_nc_ohc=LbFPvd08KBgQ7kNvwGOEgq3&_nc_oc=AdnIay_kMVNBoajL-bwoiDQVGzX-VeNalEsrsM5D8abQv9O4PjmzpEQy8F6RrWe3yhE&_nc_zt=23&_nc_ht=scontent.fyto1-1.fna&edm=APRAPSkEAAAA&_nc_gid=NiKS_-fYET_bQ-HwiPSALQ&oh=00_AfIZNuwuOQ1HMMKtOiuUnwm99iK6hnMRJN9CcnOHVGPX0A&oe=6841269F'

    // 498 x 885
    // 320 x 570

    // https://www.facebook.com/photo/?fbid=732200715161911&set=a.732186798496636
    // https://www.facebook.com/photo/?fbid=732200715161911
    // https://scontent.fyto1-2.fna.fbcdn.net/v/t39.30808-6/474657424_1112211247160854_6338088568668327312_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=f727a1&_nc_ohc=bqv91wUTsLYQ7kNvwE5LXKs&_nc_oc=AdnjNoq-OGt4QU41TZKPggRDEm-liFKe41GpMRgdIrch4LlLa6AreSUN-IM6vomw9Ew&_nc_zt=23&_nc_ht=scontent.fyto1-2.fna&_nc_gid=H-RzKhkiw10np9Lr51Ez8Q&oh=00_AfJ3fGBqyv3Ot-Hp3_1sMBDPHyk0PB2XhnHp9_oTXt3kRQ&oe=6842CA79

    // https://graph.facebook.com/732200715161911/picture?type=normal
    // https://graph.facebook.com/732200715161911/picture?redirect=false
    // https://scontent.facebook.com/v/t1.0-9/732200715161911_n.jpg

    return (
        // <div className='min-w-86 max-h-172'>
        <div className=''>
            <iframe
                className='flex w-full h-full mt-4 mb-1 rounded-lg object-cover'
                src={videoUrl}
                // width={width}
                // height={height}
                style={{ 
                    border: 'none', 
                    overflow: 'hidden'
                }}
                title=""
                allowFullScreen={true}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            />
        </div>
    );
};

export default FacebookVideo;

